module.exports = __webpack_public_path__ + "static/img/头像5.7a96835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/头像5.png
// module id = 3kzu
// module chunks = 1